import React, { useState, useEffect, useRef } from 'react';
import { useOnScreen } from 'tmt-ui-kit';

const RehydrateComponent = props => {
  const { children } = props;
  const [isShow, setIsShow] = useState(false);
  const dom = useRef(null);
  const isSeen = useOnScreen(dom, '200px');
  useEffect(() => {
    if (isSeen && !isShow) {
      setIsShow(true);
    }
  }, [isSeen]);
  if (isShow) return children;
  return (
    <div ref={dom} />
  );
};

export default RehydrateComponent;
